export class Enrollment {

    public id: string = "0";
    public created: Date;
    public event_id: string;
    public event_name: string;
    public day_id: string;
    public day_name: string;
    public day_date: Date;
    public activity_id: string;
    public activity_name: string;
    public topic_id: string;
    public topic_name: string;
    public finished: boolean;
    public member_id: string;
    public member_name: string;

    public product_id: string;
    public product_name: string;

    public type: string;
    public certificate_url: string;
 
    constructor() {}
}